import { React } from "react";

// Styles
import classStyles from "./index.module.css";

const CopyRightFooter = (props) => {
  return (
    <div className={classStyles.CopyrightFooter}>
      <p>©️ Bolt Advance 2024. Copyright reserved.</p>
    </div>
  );
};

export default CopyRightFooter;
